export default __webpack_public_path__ + "static/media/Landing_Logo_Homecenter.0a1cb0b9.png";